<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label for="itemname">
                        {{ localizationStore.translate("credit.bureau") }}
                    </label>
                    <select
                        v-model="selectedCreditBureauId"
                        @change="getCreditBureauList(selectedCreditBureauId)"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditBureauError}"
                        required
                    >
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{ creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label>&nbsp;</label>
                    <br />
                    <button @click="submitForm" type="button" class="btn btn-outline-primary btn-submit"> Dispute Selected Items</button>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="medical-table"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data" class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditBureauId" hidden>
                                <div class="col-md-6 pl-md-0 pr-md-3">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6 pl-md-3 pr-md-0 mt-3 mt-md-0">
                                    <div class="arrow-btn">
                                        <button
                                            class="btn btn-outline-primary px-50"
                                            @click="$refs.spinner.spinLetter()"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <i data-feather="arrow-right"></i>
                                        </button>
                                    </div>
                                    <div id="editor-right">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="2">
                                            {{ localizationStore.translate("letter.right.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRefSingle' />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div class="page">
                <p>
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br />
                    {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br />
                    {{ userInfo.dob }}
                    <br />
                    {{ userInfo.ssn }}
                    <br />
                    <br />
                    {{ selectedCreditBureau.name }}
                    <br />
                    <template v-if="selectedCreditBureau.address_name">
                        {{ selectedCreditBureau.address_name }}
                    </template>
                    <template v-else>
                        {{ selectedCreditBureau.street_address }}<br /> {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }} {{ selectedCreditBureau.zipcode }}
                    </template>
                    <br />
                    <br /> Date: {{ date }}
                </p>
                <p>
                    Re: Medical Violation
                </p>
                <p>
                    To {{ selectedCreditBureau.name }}:
                </p>
                <p class="letter-content">
                    Recently checked my credit reports and realized your agency and this debt collector is in violation of 15 U.S. Code § 1681a(3)Restriction on sharing of medical information.—Except for information or any communication of information disclosed as provided in, the exclusions in paragraph (2) shall not apply with respect to information disclosed to any person related by common ownership or affiliated by corporate control, if the information is—
                </p>
                <p>
                    <strong>(A)</strong>
                    <p class="letter-content">
                        medical information;
                    </p>

                    <strong>(B)</strong>
                    <p class="letter-content">
                        an individualized list or description based on the payment transactions of the consumer for medical products or services; or
                    </p>

                    <strong>(C)</strong>
                    <p class="letter-content">
                        an aggregate list of identified consumers based on payment transactions for medical products or services.
                    </p>
                </p>
                <p class="letter-content">
                    And 15 US Code 1681b(4)Limitation on redisclosure of medical information
                </p>
                <p class="letter-content">
                    Any person that receives medical information pursuant to paragraph (1) or (3) shall not disclose such information to any other person, except as necessary to carry out the purpose for which the information was initially disclosed, or as otherwise permitted by statute, regulation, or order.
                </p>
                <p class="letter-content">
                    under 15 U.S.C. Sec. 1681i(a), you must complete this reinvestigation within 30 days and you must delete the items from my credit file immediately.
                </p>
                <p v-if="disputedCreditors.length > 0" v-for="disputedCreditor in disputedCreditors">
                    <strong>NAME OF ACCOUNT:</strong> {{ disputedCreditor.furnisher_name }}
                    <br />
                    <template v-if="disputedCreditor.reference_number">
                        <strong>REFERENCE NUMBER: </strong>{{ disputedCreditor.reference_number }}<br />
                    </template>
                    <template v-else>
                        <strong>ACCOUNT NUMBER: </strong>{{ disputedCreditor.account_number }}<br>
                    </template>
                </p>
                <p>
                    Thank you for your time and help in this matter.
                    <br />
                    Sincerely,
                    <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        creditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        return {
            selectedCreditBureauId: ref(props.creditBureaus[0].id),
            editorRefSingle: ref(null),
            isInputFormActive: ref(true),
            creditBureauError: ref(false),
            date: ref(null),
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const disputedCreditors = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          disputedCreditors
        };
    },
    created() {
        // console.log(this.creditors);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditorList();
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      submitForm: function () {
        this.disputedCreditors = this.$refs['medical-table'].selectedRows;
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      dispute: function (id) {
        this.disputedCreditors = [];
        this.disputedCreditors[0] = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
            this.creditBureauError = true;
        }
        else {
            this.creditBureauError = false;
        }
        return !this.creditBureauError;
      },
      getCreditorList: function () {
        axios.get(this.routes.creditorListUrl).then(response => {
            this.rows = response.data.data
        });
      }
    }
  };
</script>
